import { render, staticRenderFns } from "./ViewMedicationAdvice.vue?vue&type=template&id=510ce8c8&scoped=true"
import script from "./ViewMedicationAdvice.vue?vue&type=script&lang=js"
export * from "./ViewMedicationAdvice.vue?vue&type=script&lang=js"
import style0 from "./ViewMedicationAdvice.vue?vue&type=style&index=0&id=510ce8c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ce8c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510ce8c8')) {
      api.createRecord('510ce8c8', component.options)
    } else {
      api.reload('510ce8c8', component.options)
    }
    module.hot.accept("./ViewMedicationAdvice.vue?vue&type=template&id=510ce8c8&scoped=true", function () {
      api.rerender('510ce8c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/ViewMedicationAdvice.vue"
export default component.exports